import { Component } from "@angular/core";
import { DataServiceService } from "../data-service.service";

@Component({
  selector: "app-partner-advance-search-test",
  templateUrl: "./partner-advance-search-test.component.html",
  styleUrls: ["./partner-advance-search-test.component.scss"],
})
export class PartnerAdvanceSearchTestComponent {
  keyword = "";
  isChineseSearch = false;

  dd = "00";
  mm = "00";
  yyyy = "0000";
  gender = "NO"; // NO | male | female

  isLoading = false;
  token = localStorage.getItem("token") || "";

  result: any = null;
  error: any = null;

  constructor(private dataService: DataServiceService) {}

  async search() {
    this.error = null;
    this.result = null;
    this.isLoading = true;

    try {
      this.token = localStorage.getItem("token") || "";
      if (!this.token) {
        throw new Error("Missing partner token: localStorage.token is empty");
      }

      this.result = await this.dataService.partnerAdvanceSearch({
        name: this.keyword,
        isChineseSearch: this.isChineseSearch,
        dd: this.dd,
        mm: this.mm,
        yyyy: this.yyyy,
        gender: this.gender,
      });
    } catch (e) {
      this.error = e;
    } finally {
      this.isLoading = false;
      this.token = localStorage.getItem("token") || "";
    }
  }

  clear() {
    this.keyword = "";
    this.result = null;
    this.error = null;
  }

  clearSavedToken() {
    localStorage.removeItem("token");
    this.token = "";
  }
}

